import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import SubmissionForm from './pages/SubmissionForm';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <header className="App-header">
          <div className="container">
            <h1>Beschaffungsportal KI-Lizenzen - Hochschule Bochum</h1>
            <nav>
              <Link to="/">Antrag einreichen</Link>
              <Link to="/admin">Admin-Bereich</Link>
            </nav>
          </div>
        </header>

        <main className="App-main">
          <Routes>
            <Route path="/" element={<SubmissionForm />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
        </main>

        <footer className="App-footer">
          <div className="container">
            <p>&copy; 2025 Beschaffungsportal KI-Lizenzen. Alle Rechte vorbehalten.</p>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
